import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useMemo } from 'react';
import { MatchContentWithProvider } from './MatchContent';

export const MatchesDate = ({
  dateKey,
  levelKey,
  sectionKey,
  matchDisplayType,
  matchScheduleDisplayType,
  forPlayoffs,
  matches,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {};
  const {
    scheduleLevelKeys: _scheduleLevelKeys,
    levelSectionDateMatches: _levelSectionDateMatches,
    scoreboardByDate: _scoreboardByDate,
    playoffScoreboardByDate: _playoffScoreboardByDate
  } = matches_groupInfo ?? {};

  const lsdms = _levelSectionDateMatches?.[levelKey]?.[dateKey]?.[sectionKey]

  const dateMatches = useMemo(() => {
    if (forPlayoffs) return;
    if (_.isEmpty(lsdms)) return <div>No Matches</div>;
    return _.map(lsdms, (match) => (
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  }, [JSON.stringify(lsdms)])

  const datePlayoffMatches = useMemo(() => {
    if (!forPlayoffs) return;
    if (_.isEmpty(_playoffScoreboardByDate)) return <div>No Playoff Matches</div>;
    return _.map(matches, (match) => (
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  }, [JSON.stringify(_playoffScoreboardByDate)])

  return forPlayoffs ? datePlayoffMatches : dateMatches

}

